export const sendConversionToSlack = (conversionType, metadata, user) => {
    let text

    switch (conversionType) {
        case 'free_trial':
            text = `*Free Trial Conversion* \n\n ${user?.email || 'anonymous user'} has started a free trial`
            break
        case 'contact_us':
            text = `
				*Contact Us Conversion* \n\n ${user?.email || metadata?.email || 'anonymous user'} has submitted the contact us form
				\n\n *Metadata* \n \`\`\`${JSON.stringify(metadata)}\`\`\`
			`
            break
        case 'request_meeting':
            text = `*Request Meeting Conversion* \n\n ${user?.email || 'anonymous user'} has booked a free demo`
            break
    }

    fetch('/.netlify/functions/slack-conversions', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text }),
    }).catch((err) => {
        console.log('Error sending conversion to slack', err)
    })
}
